import React, { useEffect, useContext } from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import createCountryQuery from '../../../../Apollo/mutations/createCountry';
import updateCoutryQuery from '../../../../Apollo/mutations/updateCountry';
import deleteCountryQuery from '../../../../Apollo/mutations/deleteCountry';
import Table from '../../../../components/Table/Table';
import TextEditor from './components/TextEditor';
import BooleanEditor from './components/BooleanEditor';
import BooleanFormatter from './services/booleanFormater';
import columns from './columnDefinition';
import DataContext from '../../../../context/DataProvider/DataContext';
import commitChanges from './commitChanges';

const textColumns = ['title'];

function TextTypeProvider() {
  return <DataTypeProvider editorComponent={TextEditor} for={textColumns} />;
}

const booleanColumns = ['is_default'];

function BooleanTypeProvider() {
  return (
    <DataTypeProvider formatterComponent={BooleanFormatter} editorComponent={BooleanEditor} for={booleanColumns} />
  );
}

const Provider = [TextTypeProvider, BooleanTypeProvider];

function AllCoutrysTable() {
  const { country, loaderFun } = useContext(DataContext);
  const { enqueueSnackbar } = useSnackbar();
  const [createCountry, { reset: resetCreate }] = useMutation(createCountryQuery);
  const [updateCountry, { reset: resetUpdate }] = useMutation(updateCoutryQuery);
  const [deleteCountry] = useMutation(deleteCountryQuery);

  useEffect(() => {
    loaderFun.loadCountry();
  }, []);

  const editingStateColumnExtensions = [{ columnName: 'id', editingEnabled: false }];

  return (
    <Table
      usageName="einstellungen.laender"
      row={country}
      columns={columns}
      defaultColumnWidths={columns.map((column) => ({ columnName: column.name, width: 'auto' }))}
      onCommitChanges={({ added, changed, deleted }) =>
        commitChanges({
          added,
          changed,
          deleted,
          rows: country,
          loaderFun,
          createCountry,
          updateCountry,
          deleteCountry,
          resetCreate,
          resetUpdate,
          enqueueSnackbar,
        })
      }
      columnExtensions={editingStateColumnExtensions}
      dataTypeProvider={Provider}
      editable
      showAddCommand
      showEditCommand
      showDeleteCommand
    />
  );
}

export default AllCoutrysTable;
